import { render, staticRenderFns } from "./EditProfileWhatsapp.vue?vue&type=template&id=32dd1828&scoped=true"
import script from "./EditProfileWhatsapp.vue?vue&type=script&lang=js"
export * from "./EditProfileWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./EditProfileWhatsapp.vue?vue&type=style&index=0&id=32dd1828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd1828",
  null
  
)

export default component.exports